import {
  Box,
  Button,
  createStyles,
  Dialog,
  DialogContent,
  Divider,
  makeStyles,
  TextField,
  Theme,
  withStyles
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getParticipantList, manageParticipantList} from "../../../../store/actions/participant/list";

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    maxWidth: 500,
    borderRadius: '24px!important'
  },
  btn: {
    width: 87,
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  cancelBtn: {
    margin: '0 15px',
    height: 37,
    borderRadius: 6,
    background: '#f2f2f2',
    textTransform: 'none',
    fontSize: 14,
    color: '#697683',
    '&:hover': {
      background: '#f2f2f2',
    },
  },
  contentText: {
    marginTop: '12px',
    fontFamily: 'roboto-regular',
  },
  label: {
    "&$focusedLabel": {
      fontSize: 12,
      fontFamily: 'roboto-bold',
      color: "#606B76"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
}));

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const DialogTitle = withStyles(styles)((props: any) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

interface IProps {
  open: boolean,
  onClose: () => void,
  selectedList: any
}

const RenameList = (props: IProps) => {
  const classes = useStyles();
  const { open, onClose, selectedList } = props;
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [listName, setListName] = useState('');
  const [updateDisabled, setUpdateDisabled] = useState(true);

  useEffect(() => {
    if (open && selectedList && selectedList.group_name) {
      setListName(selectedList.group_name);
    }
  }, [open, selectedList]);

  const onCloseModal = () => {
    onClose();
    setListName('');
    setUpdateDisabled(true);
  };

  const onChangeName = (event: any) => {
    setListName(event.target.value);
    if (!event.target.value) {
      setUpdateDisabled(true);
      return
    }
    if (selectedList.name === event.target.value) {
      setUpdateDisabled(true)
    } else {
      setUpdateDisabled(false)
    }
  };

  const onListRename = () => {
    const request = {
      group_id: Number(selectedList.group_id),
      group_name: listName
    };
    dispatch(manageParticipantList(apolloClient.client, request, false, (res: boolean) => {
      if (res) {
        dispatch(getParticipantList(apolloClient.client, false));
      }
    }));
    onCloseModal();
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      scroll='paper'
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <DialogTitle onClose={onCloseModal}>
        Rename List
      </DialogTitle>
      <Divider/>
      <DialogContent>
        <Box>
          <div className={classes.contentText}>
            <TextField
              value={listName}
              InputLabelProps={{
                classes: {
                  root: classes.label,
                  focused: classes.focusedLabel,
                  error: classes.erroredLabel
                },
              }}
              InputProps={{
                classes: {
                  root: classes.underline,
                  error: classes.error
                }
              }}
              fullWidth
              size="small"
              id="listName"
              label="List Name"
              name="listName"
              onChange={onChangeName}
            />
          </div>
        </Box>
      </DialogContent>

      <Box mt={3} mb={3} mr={4} display='flex' justifyContent='flex-end'>
        {selectedList &&
        <>
          <Button className={classes.cancelBtn} onClick={onCloseModal}>
            Cancel
          </Button>
          <Button
            color='primary'
            disabled={updateDisabled}
            className={classes.btn}
            onClick={onListRename}
            style={ updateDisabled ? { color: '#FFF', opacity: 0.6 } : {}}
          >
            Update
          </Button>
        </>
        }
      </Box>
    </Dialog>
  )
};

export default RenameList;